export default __webpack_public_path__ + "static/media/Rubik-SemiBold.52d2adf4.ttf";